"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const StyledFunctions_1 = require("../../helpers/StyledFunctions");
const Modal_1 = tslib_1.__importDefault(require("../Modal"));
const Toggle_1 = tslib_1.__importDefault(require("../Toggle"));
const Button_1 = tslib_1.__importDefault(require("./Button"));
const AlertModal_1 = tslib_1.__importDefault(require("./components/AlertModal"));
const defaultProps = {};
const AlertButton = ({ children, onConfirm, confirmButtonLabel, cancelButtonLabel, alertMessage, alertTitle, minWidth, ...restProps }) => (react_1.default.createElement(Toggle_1.default, null, ({ isActive, on, off }) => {
    const { elementTypes } = (0, StyledFunctions_1.extractElementType)(restProps);
    const { elementSizes } = (0, StyledFunctions_1.extractElementSize)(restProps);
    const { margins, paddings } = (0, StyledFunctions_1.extractMarginAndPadding)(restProps);
    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm();
        }
        off();
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Button_1.default, { ...elementTypes, ...elementSizes, ...margins, ...paddings, minWidth: minWidth, onClick: on }, children),
        react_1.default.createElement(Modal_1.default, { isOpen: isActive, onRequestToClose: off },
            react_1.default.createElement(AlertModal_1.default, { ...elementTypes, title: alertTitle, message: alertMessage, confirmButton: confirmButtonLabel, cancelButton: cancelButtonLabel, onConfirm: handleConfirm, onCancel: off }))));
}));
AlertButton.defaultProps = defaultProps;
exports.default = AlertButton;
